import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState } from 'react';
import styled from 'styled-components';
import { IconButton, Menu as MuiMenu } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useIsDesktop } from '../../../hooks';
import { OnCloseMenuProvider } from '../hooks';
import MenuIcon from './MenuIcon';
var useStyles = makeStyles(function (theme) {
  return {
    menu: {
      backgroundColor: theme.palette.primary.main
    }
  };
});
var DesktopContainer = styled.ol(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"])));

var Menu = function Menu(_a) {
  var children = _a.children,
      _a$iconProps = _a.iconProps,
      iconProps = _a$iconProps === void 0 ? {} : _a$iconProps,
      _a$label = _a.label,
      label = _a$label === void 0 ? 'menu' : _a$label,
      rest = __rest(_a, ["children", "iconProps", "label"]);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      menuAnchor = _useState2[0],
      setMenuAnchor = _useState2[1];

  var classes = useStyles();
  var isDesktop = useIsDesktop();

  var onMenuOpen = function onMenuOpen(event) {
    return setMenuAnchor(event.currentTarget);
  };

  var onMenuClose = function onMenuClose() {
    return setMenuAnchor(undefined);
  };

  React.useEffect(function () {
    if (isDesktop) {
      onMenuClose();
    }
  }, [isDesktop]);
  return isDesktop ? React.createElement(DesktopContainer, Object.assign({}, rest), children) : React.createElement(React.Fragment, null, React.createElement(IconButton, Object.assign({
    "aria-label": label,
    onClick: onMenuOpen
  }, iconProps), React.createElement(MenuIcon, null)), React.createElement(OnCloseMenuProvider, {
    onClose: onMenuClose
  }, React.createElement(MuiMenu, {
    anchorEl: menuAnchor,
    classes: {
      paper: classes.menu
    },
    keepMounted: true,
    open: Boolean(menuAnchor),
    onClose: onMenuClose
  }, children)));
};

Menu.displayName = 'Navbar.Menu';
var MenuExtra = styled(Menu)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
export default MenuExtra;